import { motion } from "framer-motion";
import { SITE } from "@/data/site";

export const About = () => {
  return (
    <section id="hakkimizda" className="py-24 lg:py-32 cream-grain relative">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-4"
        >
          <span className="eyebrow">Marka</span>
          <h2 className="font-display text-4xl lg:text-5xl text-[hsl(var(--nl-anthracite))] mt-4 leading-[1.05]">
            NovaLand <br />
            <em className="not-italic font-serif italic gold-text">Hakkında</em>
          </h2>
          <div className="gold-line mt-6" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-8 space-y-5 text-[15px] lg:text-base leading-[1.85] text-[hsl(var(--nl-anthracite))/0.85]"
          data-testid="about-text"
        >
          {SITE.about.split("\n\n").map((p, i) => (
            <p key={i} className={i === 0 ? "first-letter:font-serif first-letter:text-5xl first-letter:gold-text first-letter:mr-2 first-letter:float-left first-letter:leading-[0.9]" : ""}>
              {p}
            </p>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default About;
